export const EXPRESS_DESIGNER_EVENT_ACTION = 'ExpressProdukt';
export const EXPRESS_DESIGNER_PRODUCT_GALLERY_ID = 'express-product-gallery';
